<div class="max-h-[350px]">
  <p-chart type="bar" [data]="data" [options]="chartOptions" [height]="'350px'" />
  @if(isDownloadable) {
    <div class="flex justify-end mt-2">
      <button pButton label="Descargar" icon="pi pi-download" class="p-button-sm p-button-outlined" (click)="download()"></button>
    </div>
  }
</div>
